import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { SyncState } from '@rocksoft/apple-sync-sdk';

@Component({
  selector: 'era-device-sync-status-indicator',
  templateUrl: './device-sync-status-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent],
})
export class DeviceSyncStatusIndicatorComponent {
  syncState = SyncState;
  readonly status = input.required<SyncState>();
}
